import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=565ba20e&scoped=true&"
import script from "./Funds.vue?vue&type=script&lang=js&"
export * from "./Funds.vue?vue&type=script&lang=js&"
import style0 from "./Funds.vue?vue&type=style&index=0&id=565ba20e&scoped=true&lang=css&"
import style1 from "./Funds.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ba20e",
  null
  
)

export default component.exports